import React, { useState, useEffect, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useParams } from "react-router-dom";
import {
  TOKEN_NAME,
  APP_VERSION,
  CANCEL_REQUEST,
  WS_URL,
  DATE_TIME_FORMAT,
} from "constants/index";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Space,
  message,
  Empty,
  Spin,
  Input,
  InputNumber,
  Layout,
  Form,
} from "antd";
import { UserOutlined, KeyOutlined } from "@ant-design/icons";
import emptyImg from "../assets/img/empty.svg";
import NoteService from "services/note.service";
import axios from "axios";
import moment from "moment";
import { SocketContext } from "contexts/SocketContext";
import { AppContext } from "contexts/AppContext";

const { Header, Content, Footer } = Layout;
const { TextArea } = Input;
const initialValues = {
  content: "",
};

let timeOut = null;

const Note = (props) => {
  const socket = useContext(SocketContext);
  const appContext = useContext(AppContext);
  const dispatch = useDispatch();
  const { note_id } = useParams();
  const [form] = Form.useForm();
  const inputNote = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [wsMessage, setWSMessage] = useState("");
  const [note, setNote] = useState(null);
  const [dateType, setDateType] = useState(true);

  useEffect(() => {
    socket.on("update-note", (obj, msg) => {
      if (note_id && obj.id == note_id) {
        setNote(obj);
        form.setFieldsValue({ content: obj.content });
        setTimeout(() => {
          message.success(msg);
        }, 500);
      }
      socket.emit("request-note-list");
    });

    if (note_id) {
      setDateType(true);
      appContext.setSelectedNote(note_id);
      onSearch(note_id);
    } else {
      setNote(null);
      appContext.setSelectedNote(null);
      inputNote.current.focus();
    }
  }, [socket, note_id]);

  const onSearch = (id) => {
    setIsLoading(true);
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    NoteService.getItem(id, source).then(
      (request) => {
        appContext.setIsOwner(request.is_owner);
        setNote(request.note);
        form.setFieldsValue(request.note);
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      },
      (error) => {
        if (error && error.message !== CANCEL_REQUEST) {
          message.error("API got error, please contact us.", 5);
        }
        console.log(error);
        setIsLoading(false);
        return Promise.reject();
      }
    );
  };

  const onClear = () => {
    form.setFieldsValue(initialValues);
  };

  const handleAutoSave = (e) => {
    if (note_id) {
      form
        .validateFields()
        .then((params) => {
          message.warning("Saving data...");
          if (note_id) {
            socket.emit("edit-note", { ...params, id: note_id });
          }
        })
        .catch((e) => {
          message.warning("Please check the form validation");
        });
    }
  };

  const handleSubmit = (e) => {
    form
      .validateFields()
      .then((params) => {
        console.log(params);
        setIsLoading(true);
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        message.warning("Saving data...");
        if (note_id) {
          NoteService.updateItem({ ...params, id: note_id }, source).then(
            (request) => {
              message.info("Item successfully updated", 5);
              onClear();
              setTimeout(() => {
                setIsLoading(false);
                socket.emit("request-note-list");
              }, 500);
            },
            (error) => {
              if (error && error.response.data && error.response.data.errors) {
                message.error(error.response.data.errors.join(". "), 5);
              } else if (error && error.message !== CANCEL_REQUEST) {
                message.error("API got error, please contact us.", 5);
              }
              console.log(error);
              setIsLoading(false);
              return Promise.reject();
            }
          );
        } else {
          NoteService.createItem(params, source).then(
            (request) => {
              message.info("Item successfully created", 5);
              onClear();
              setTimeout(() => {
                setIsLoading(false);
                socket.emit("request-note-list");
              }, 500);
            },
            (error) => {
              if (error && error.response.data && error.response.data.errors) {
                message.error(error.response.data.errors.join(". "), 5);
              } else if (error && error.message !== CANCEL_REQUEST) {
                message.error("API got error, please contact us.", 5);
              }
              console.log(error);
              setIsLoading(false);
              return Promise.reject();
            }
          );
        }
      })
      .catch((e) => {
        message.warning("Please check the form validation");
      });
  };

  return (
    <>
      <Content>
        <Row gutter={16} justify="space-around" align="middle">
          <Col span={24}>
            <Form
              layout="vertical"
              initialValues={initialValues}
              form={form}
              className="note-panel"
            >
              <Space direction="vertical" size="very-small">
                <h5 onClick={() => setDateType(!dateType)}>
                  {dateType
                    ? `Created ${moment(note?.created_date).format(
                        DATE_TIME_FORMAT.DATETIME
                      )}`
                    : `Edited ${moment(note?.updated_date).format(
                        DATE_TIME_FORMAT.DATETIME
                      )}`}
                </h5>
                <Form.Item name="content">
                  <TextArea
                    showCount
                    maxLength={255}
                    className="note-area"
                    autoSize={true}
                    bordered={false}
                    ref={inputNote}
                    onKeyUp={(e) => {
                      clearTimeout(timeOut);
                      timeOut = setTimeout(() => {
                        handleAutoSave(e);
                      }, 1000);
                    }}
                  />
                </Form.Item>
                <div>
                  <Button
                    onClick={() => props.history.push("/main/overview")}
                    style={{ marginRight: 8 }}
                  >
                    Cancel
                  </Button>
                  <Button onClick={(e) => handleSubmit(e)} type="primary">
                    Save
                  </Button>
                </div>
              </Space>
            </Form>
          </Col>
        </Row>
      </Content>
    </>
  );
};

export default Note;
